/**
 * AUTO-GENERATED FILE — Do not edit manually.
 *
 * To regenerate, run from oc-web/:
 *   `nx run enterprise:fetch-ld-flags`
 *   or
 *   `npx tsx packages/enterprise/scripts/fetchLdFlags.ts`
 */

/* biome-ignore-all lint/style/useNamingConvention: auto-generated enum members match LaunchDarkly flag keys */

export namespace OcDarklyFlags {
  export enum BooleanFlag {
    abacAttributePreload = 'abac-attribute-preload',
    abacCheckDescendants = 'abac-check-descendants',
    abacDescendantSkeleton = 'abac-descendant-skeleton',
    abacJobApplicationPreload = 'abac-job-application-preload',
    abacManagingSources = 'abac-managing-sources',
    abacVerboseLogging = 'abac-verbose-logging',
    activeWorkerCountWithoutIntersect = 'active-worker-count-without-intersect',
    addExpiryCookie = 'add-expiry-cookie',
    aiAssistant = 'ai-assistant',
    allowModificationOfFieldMetadataInRuntime = 'allow-modification-of-field-metadata-in-runtime',
    analyticsDashboards = 'analyticsDashboards',
    applyWorkerIdPrefix = 'apply-worker-id-prefix',
    auditLookupStrategyModifiedField = 'audit-lookup-strategy-modified-field',
    autoResizeAnalyticsDashboard = 'auto-resize-analytics-dashboard',
    backfillJobApplicationCreatedBusinessEventsScheduler = 'backfill-job-application-created-business-events-scheduler',
    batchEngagementManagerFallback = 'batch-engagement-manager-fallback',
    batchEngagementMember = 'batch-engagement-member',
    batchLoadCustomFieldDefinitionValues = 'batch-load-custom-field-definition-values',
    batchOcHolidayScheduleRequests = 'batch-oc-holiday-schedule-requests',
    batchOcWorkScheduleRequests = 'batch-oc-work-schedule-requests',
    batchOrgMembersSortManagers = 'batch-org-members-sort-managers',
    batchOrgMembershipRevisions = 'batch-org-membership-revisions',
    batchOrgMembershipRevisionsV2 = 'batch-org-membership-revisions-v2',
    businessEvents = 'business-events',
    businessEventsTopicV2 = 'business-events-topic-v2',
    cacheDetailsLogOnMismatch = 'cache-details-log-on-mismatch',
    cacheForceInitialRefresh = 'cache-force-initial-refresh',
    cacheRepopulateOnMismatch = 'cache-repopulate-on-mismatch',
    calculateJobApplicationBudget = 'calculate-job-application-budget',
    calculateWorkPostingBudget = 'calculate-work-posting-budget',
    camundaProcessEngineEnableCmdExceptionLogging = 'camunda-process-engine-enable-cmd-exception-logging',
    changesetCustomFieldsDeltaGuard = 'changeset-custom-fields-delta-guard',
    changesetTaeAppendixSupport = 'changeset-tae-appendix-support',
    chaseReportLiteActuator = 'chase-report-lite-actuator',
    clientSupportLinks = 'client-support-links',
    complianceAndRisksWidget = 'compliance-and-risks-widget',
    complianceCertificationManagement = 'compliance-certification-management',
    continueFailedJobApplication = 'continue-failed-job-application',
    contractAlertsSection = 'contract-alerts-section',
    contractApproveChangeTask = 'contract-approve-change-task',
    contractCompanyCostCentreRelationship = 'contract-company-cost-centre-relationship',
    contractCurrencyValidation = 'contract-currency-validation',
    contractDetailsCompany = 'contract-details-company',
    contractHub = 'contract-hub',
    contractSpend = 'contract-spend',
    contractsInTae = 'contracts-in-tae',
    costCenterWithFinancialFieldsGroup = 'cost-center-with-financial-fields-group',
    costsBypassTaeDisabledCheck = 'costs-bypass-tae-disabled-check',
    criteriaMatcherCache = 'criteria-matcher-cache',
    currencyFieldInExpenseCategory = 'currency-field-in-expense-category',
    customFieldsHaveHierarchicalPermissions = 'custom-fields-have-hierarchical-permissions',
    customManagingSourceIcons = 'custom-managing-source-icons',
    customizeStandardReport = 'customize-standard-report',
    dailyBriefing = 'daily-briefing',
    dataConnectorExtracts = 'dataConnectorExtracts',
    dateEffectiveEngagementUpdates = 'date-effective-engagement-updates',
    defaultActiveUsers = 'default-active-users',
    deleteDocumentsMissingInCustomFields = 'delete-documents-missing-in-custom-fields',
    demographicInfoTask = 'demographic-info-task',
    devTools = 'dev-tools',
    disableTutorials = 'disable-tutorials',
    documentsAntivirusScan = 'documents-antivirus-scan',
    downloadWorkdaySnapshot = 'download-workday-snapshot',
    duplicateSearch = 'duplicate-search',
    dynamicAnalyticsConfig = 'dynamic-analytics-config',
    engagementBatchLoaderGrouping = 'engagement-batch-loader-grouping',
    engagementBudget = 'engagement-budget',
    engagementCacheOrgUidPopulate = 'engagement-cache-org-uid-populate',
    engagementCacheOrgUidUse = 'engagement-cache-org-uid-use',
    engagementContractDateValidation = 'engagement-contract-date-validation',
    engagementDuplicateCheck = 'engagement-duplicate-check',
    engagementRatesFromOc = 'engagement-rates-from-oc',
    engagementSpend = 'engagement-spend',
    enterpriseProjectTasks = 'enterprise-project-tasks',
    enterpriseProjects = 'enterprise-projects',
    erUnificationWorkers = 'er-unification-workers',
    exceptionDebuggingEndpoint = 'exception-debugging-endpoint',
    expenseAttributesStrategyImprovement = 'expense-attributes-strategy-improvement',
    expenseIndexEngagementSupplierSupport = 'expense-index-engagement-supplier-support',
    expenses = 'expenses',
    experimentalEngagementBudgetCalculator = 'experimental-engagement-budget-calculator',
    exportRateCards = 'export-rate-cards',
    extendJobFamilyGroup = 'extend-job-family-group',
    extendedTimesheetExportNotifications = 'extended-timesheet-export-notifications',
    externalIntegrations = 'external-integrations',
    financeFields = 'finance-fields',
    financeJournalConfig = 'financeJournalConfig',
    fixRatesChangeHistoryInApprovalTask = 'fix-rates-change-history-in-approval-task',
    fullscreenFormBounceAppHide = 'fullscreen-form-bounce-app-hide',
    granularReportScheduleIntervals = 'granular-report-schedule-intervals',
    hideAddJobPostingButton = 'hide-add-job-posting-button',
    hideDeprecatedRates = 'hide-deprecated-rates',
    hideInvoicePayments = 'hide-invoice-payments',
    hideNotImplementedRateFrequencies = 'hide-not-implemented-rate-frequencies',
    imageResizer = 'image-resizer',
    importEngagementAppendixFields = 'import-engagement-appendix-fields',
    importerEngagementRetroChangesValidation = 'importer-engagement-retro-changes-validation',
    importerOpenChangeSetValidation = 'importer-open-change-set-validation',
    inAppDocumentationDrawer = 'in-app-documentation-drawer',
    includeInvoiceLineItems = 'include-invoice-line-items',
    interviewScheduling = 'interview-scheduling',
    invoiceImportSemanticVersionValidationShared = 'invoice-import-semantic-version-validation-shared',
    invoicePerformanceImprovements = 'invoice-performance-improvements',
    invoicingHtmlTemplate = 'invoicing-html-template',
    jobApplicationDuplicateCheck = 'job-application-duplicate-check',
    jobApplicationPrimaryNationalIdentificationV2 = 'job-application-primary-national-identification-v2',
    jobApplicationStageBatchLoad = 'job-application-stage-batch-load',
    jobApplicationToEngagementLink = 'job-application-to-engagement-link',
    jobPostingBusinessReason = 'job-posting-business-reason',
    jobPostingPauseResumeBusinessEvents = 'job-posting-pause-resume-business-events',
    jobPostingSeniority = 'job-posting-seniority',
    jobPostingSupplierGroups = 'job-posting-supplier-groups',
    jobProfileAiSummary = 'job-profile-ai-summary',
    kafkaEngagementChangeEvents = 'kafka-engagement-change-events',
    languageSwitcher = 'language-switcher',
    logInvoiceLineItemIdHashInputs = 'log-invoice-line-item-id-hash-inputs',
    mazeSnippet = 'maze-snippet',
    mediaAntivirusScans = 'media-antivirus-scans',
    memoizeEngagementRevisionChangesets = 'memoize-engagement-revision-changesets',
    memoizeEngagementRevisionJobProfiles = 'memoize-engagement-revision-job-profiles',
    migrateFinancialFieldsMultivalued = 'migrate-financial-fields-multivalued',
    migrateTimeAndExpensesHubToggle = 'migrate-time-and-expenses-hub-toggle',
    moveHolidayScheduleToOc = 'move-holiday-schedule-to-oc',
    nationalIdLegacySuppressionBehaviour = 'national-id-legacy-suppression-behaviour',
    naturalLanguageReportBuilder = 'natural-language-report-builder',
    newDashboard = 'new-dashboard',
    newSanitizeObjectKeys = 'new-sanitize-object-keys',
    newSmartformEditorUi = 'new-smartform-editor-ui',
    newSupplierProfile = 'new-supplier-profile',
    newUiForGroupedSmartFormComponents = 'new-ui-for-grouped-smart-form-components',
    ocNotifications = 'oc-notifications',
    openJobPostings = 'open-job-postings',
    orgNavigatorNewDesign = 'org-navigator-new-design',
    orgTreeProgrammaticCopy = 'org-tree-programmatic-copy',
    patchOnlyChangedValuesInWorkerProfile = 'patch-only-changed-values-in-worker-profile',
    peopleSearchByDeprecatedUtmost = 'people-search-by-deprecated-utmost',
    performDuplicateCheckReportUrlRewrite = 'perform-duplicate-check-report-url-rewrite',
    performEngagementRatesMigration = 'perform-engagement-rates-migration',
    personNotifyGwgSelfUpdate = 'person-notify-gwg-self-update',
    postgreSqlAnyConstructQueries = 'postgre-sql-any-construct-queries',
    postgresArrayAnySearchInstrumentation = 'postgres-array-any-search-instrumentation',
    prefetchOrgMembersSortPeople = 'prefetch-org-members-sort-people',
    preloadCustomObjectFieldValues = 'preload-custom-object-field-values',
    preloadPeopleJobProfiles = 'preload-people-job-profiles',
    preloadPeopleManagedOrgs = 'preload-people-managed-orgs',
    preloadPeopleManagers = 'preload-people-managers',
    preloadPeopleOrgMemberships = 'preload-people-org-memberships',
    preloadPersonAndEngagementFields = 'preload-person-and-engagement-fields',
    preloadRevisionReferenceData = 'preload-revision-reference-data',
    preloadWorkerEngagementFields = 'preload-worker-engagement-fields',
    processTriggerOutbox = 'process-trigger-outbox',
    projectCustomFieldMappingsInFlow = 'project-custom-field-mappings-in-flow',
    ratesConfigInOc = 'rates-config-in-oc',
    readinessProbeWaitsForTimesheetIndex = 'readiness-probe-waits-for-timesheet-index',
    readonlySmartformTasks = 'readonly-smartform-tasks',
    reconcileRecentItems = 'reconcile-recent-items',
    redirectHomeInactiveSmartForms = 'redirect-home-inactive-smart-forms',
    removeCandidateApproveRejectButton = 'remove-candidate-approve-reject-button',
    removeOrgMembershipsWhenRemovingEngagement = 'remove-org-memberships-when-removing-engagement',
    reportFinancialFieldFilters = 'report-financial-field-filters',
    reportWorkerQualificationsTemplate = 'report-worker-qualifications-template',
    requestInvoiceUidsForAbac = 'requestInvoiceUidsForAbac',
    requirednessOnFinancialFieldLevel = 'requiredness-on-financial-field-level',
    requireExistenceDetectionFieldsAreUnique = 'requireExistenceDetectionFieldsAreUnique',
    rescindApprovedCandidates = 'rescind-approved-candidates',
    resetEngagementRatesMigration = 'reset-engagement-rates-migration',
    resolveStuckTaskActuator = 'resolve-stuck-task-actuator',
    retryTaeNoResponseException = 'retry-tae-no-response-exception',
    roleAssignmentUserValidation = 'role-assignment-user-validation',
    roleBasedAccessForAnalytics = 'role-based-access-for-analytics',
    rolePeopleBatchLoad = 'role-people-batch-load',
    runHistoricalReport = 'run-historical-report',
    scalableAnomalies = 'scalable-anomalies',
    scheduleReassignTasks = 'schedule-reassign-tasks',
    selectTypeaheadInfiniteScroll = 'select-typeahead-infinite-scroll',
    selectTypeaheadMultiWrap = 'select-typeahead-multi-wrap',
    showJobProfileCreationOption = 'show-job-profile-creation-option',
    sideLoadWorkdayData = 'side-load-workday-data',
    skipInactivePersonsAsTaskAssignees = 'skip-inactive-persons-as-task-assignees',
    skipInactiveUsersAsTaskAssignees = 'skip-inactive-users-as-task-assignees',
    smartFormTouchFocusBlurTracking = 'smart-form-touch-focus-blur-tracking',
    smartformValidationV2 = 'smartform-validation-v-2',
    sourcingConfig = 'sourcing-config',
    sourcingTenantReadinessCheck = 'sourcing-tenant-readiness-check',
    stableAllocationKeyHashcode = 'stable-allocation-key-hashcode',
    strongPasswordPolicy = 'strongPasswordPolicy',
    subProcessStartEventDefinitionScanner = 'sub-process-start-event-definition-scanner',
    suggesterAbac = 'suggester-abac',
    suggesterSearchLike = 'suggester-search-like',
    suggesterSinglePerson = 'suggester-single-person',
    supplierCandidatePersonUidLookup = 'supplier-candidate-person-uid-lookup',
    supplierPaymentTerms = 'supplier-payment-terms',
    supplierSearchSplitCountQuery = 'supplier-search-split-count-query',
    supportWidget = 'support-widget',
    syncTimerEvents = 'sync-timer-events',
    synchronize_financial_field_values = 'synchronize_financial_field_values',
    taeEngagementSyncStreaming = 'tae-engagement-sync-streaming',
    taeEntityRevisions = 'tae-entity-revisions',
    taeHubsApprovedDateFilter = 'tae-hubs-approved-date-filter',
    taeHubsDateWindow = 'tae-hubs-date-window',
    taeHubsExpenseTimePeriodFilter = 'tae-hubs-expense-time-period-filter',
    taeHubsLastUpdatedDateFilter = 'tae-hubs-last-updated-date-filter',
    taeInvoiceHubImprovements = 'tae-invoice-hub-improvements',
    taeValidationForTimesheetCorrectionImport = 'tae-validation-for-timesheet-correction-import',
    taskListWorkerName = 'taskListWorkerName',
    teamsNotification = 'teams-notification',
    tenantFeatureStructureValidation = 'tenant-feature-structure-validation',
    tenantFeatureUpdaterOff = 'tenant-feature-updater-off',
    testFeatureKey = 'test-feature-key',
    testingSentryIntegrationWithLD = 'testing-sentry-integration-with-LD',
    textFieldSendsNullForEmptyString = 'text-field-sends-null-for-empty-string',
    timeAndExpenseAuditReports = 'time-and-expense-audit-reports',
    timesheetAndExpensesHub = 'timesheet-and-expenses-hub',
    timesheetImportCostCenterFromEngagement = 'timesheet-import-cost-center-from-engagement',
    timesheetMultiApproval = 'timesheet-multi-approval',
    timesheetRuleCalculationVerboseLogging = 'timesheet-rule-calculation-verbose-logging',
    timesheetSettingsBusinessSite = 'timesheet-settings-business-site',
    timesheetSourceTimeAllocations = 'timesheet-source-time-allocations',
    timezoneAwareEngagementProcessLaunching = 'timezone-aware-engagement-process-launching',
    totalReportsCountByClassificationDb = 'total-reports-count-by-classification-db',
    trackUnusedGqlFields = 'track-unused-gql-fields',
    transactionRoutingDatasource = 'transaction-routing-datasource',
    triggerHsr = 'trigger-hsr',
    triggerOriginalBudgetRecalculation = 'trigger-original-budget-recalculation',
    uiNewInvoiceSettingsPage = 'ui-new-invoice-settings-page',
    uiOrgPickerV2 = 'ui-org-picker-v2',
    uiRestrictCurrencies = 'ui-restrict-currencies',
    updateCamundaDatabaseSchema = 'update-camunda-database-schema',
    useAllowedOriginPatterns = 'use-allowed-origin-patterns',
    useInlineJooqQuery = 'use-inline-jooq-query',
    userImporter = 'userImporter',
    validateContractContractingParty = 'validate-contract-contracting-party',
    validateFieldMetadataOnSetAndReset = 'validate-field-metadata-on-set-and-reset',
    validateOcRatesCorrectness = 'validate-oc-rates-correctness',
    validateProrationRuleCoverage = 'validate-proration-rule-coverage',
    validateUsingFieldMetadataOnBackend = 'validate-using-field-metadata-on-backend',
    validateWorkHolidayScheduleUpdates = 'validate-work-holiday-schedule-updates',
    workPostingToGwgSupplierRates = 'work-posting-to-gwg-supplier-rates',
    workRequestAssociatedOutcomes = 'work-request-associated-outcomes',
    workScheduleInOc = 'work-schedule-in-oc',
    workdayConfiguration = 'workdayConfiguration',
    workerProfileGlobalId = 'worker-profile-global-id',
    workerSearchIncludeDeactivated = 'worker-search-include-deactivated'
  }

  export enum StringFlag {
    auditLookupStrategy = 'audit-lookup-strategy',
    auditReportCards = 'audit-report-cards',
    SENTRY_SAMPLING_RATE = 'SENTRY_SAMPLING_RATE',
    SENTRY_SAMPLING_RATE_BPE_WEB = 'SENTRY_SAMPLING_RATE_BPE_WEB',
    sentrySamplingRate = 'sentry-sampling-rate'
  }

  export enum NumberFlag {
    flatfileColumnValidationThreshold = 'flatfileColumnValidationThreshold',
    mixpanelSessionRecording = 'mixpanel-session-recording',
    suggesterSimilarityThreshold = 'suggester-similarity-threshold'
  }

  export enum JsonFlag {}
}

export namespace GlobalDarklyFlags {
  export enum BooleanFlag {
    abacAiAssistant = 'abac-ai-assistant',
    blueprintProcessTrigger = 'blueprint-process-trigger',
    bpDocsAiChatbot = 'bp-docs-ai-chatbot',
    bulkTimesheetCorrection = 'bulk-timesheet-correction',
    clockInOutTimesheetRules = 'clock-in-out-timesheet-rules',
    configureWorkerIdPrefixViaSettingsUi = 'configure-worker-id-prefix-via-settings-ui',
    contractAddWorkerPrefill = 'contract-add-worker-prefill',
    costsQueryV3 = 'costs-query-v3',
    createBlueprintSchedule = 'create-blueprint-schedule',
    dailyUnits = 'daily-units',
    dynamicBatch = 'dynamic-batch',
    enrichTemplatesInEr = 'enrich-templates-in-er',
    erUnificationContracts = 'er-unification-contracts',
    erUnificationInvoices = 'er-unification-invoices',
    erUnificationTimesheets = 'er-unification-timesheets',
    expenseAiParsing = 'expense-ai-parsing',
    expenseMultiApproval = 'expense-multi-approval',
    failBatchBeforeSyncProcessingForTesting = 'fail-batch-before-sync-processing-for-testing',
    failBatchDuringAsyncProcessingForTesting = 'fail-batch-during-async-processing-for-testing',
    failBatchDuringSyncProcessingForTesting = 'fail-batch-during-sync-processing-for-testing',
    financeHeadcountReportsVisible = 'finance-headcount-reports-visible',
    financeSnapshotReportsVisible = 'finance-snapshot-reports-visible',
    forcedTimesheetMonthlySplitting = 'forced-timesheet-monthly-splitting',
    hideProgramInfoFromSupplierView = 'hide-program-info-from-supplier-view',
    hsrV2 = 'hsr-v2',
    invoicing20 = 'invoicing-2-0',
    invoicingSupplierFileConfig = 'invoicing-supplier-file-config',
    isAsymmetricErSigning = 'is-asymmetric-er-signing',
    isAsymmetricOcSigning = 'is-asymmetric-oc-signing',
    isAsymmetricTaeSigning = 'is-asymmetric-tae-signing',
    kafkaOnlyExportNotifications = 'kafka-only-export-notifications',
    lineItemClientAndSupplierAmounts = 'line-item-client-and-supplier-amounts',
    milestoneCorrections = 'milestone-corrections',
    monthlyTimesheets = 'monthly-timesheets',
    multipleCostCenters = 'multiple-cost-centers',
    noInitialTotalCount = 'no-initial-total-count',
    onlyNewExportsMitigation = 'only-new-exports-mitigation',
    permissionsAiAssistant = 'permissions-ai-assistant',
    prorationRules = 'proration-rules',
    rejectPendingAndDraftInvoicesForInvoicing20 = 'reject-pending-and-draft-invoices-for-invoicing-2-0',
    remainingHubsExportUnification = 'remaining-hubs-export-unification',
    reportInvoicingTemplate = 'report-invoicing-template',
    requiresActionReasons = 'requires-action-reasons',
    roundInvoiceTotal = 'round-invoice-total',
    roundTimesheetsAndExpensesHalfUp = 'round-timesheets-and-expenses-half-up',
    scaleDownMitigation = 'scale-down-mitigation',
    sdrFeesSubtotals = 'sdr-fees-subtotals',
    sdrFiltersPermittedRecords = 'sdr-filters-permitted-records',
    sdrMeetsMilestones = 'sdr-meets-milestones',
    sdrSupplierCustomFields = 'sdr-supplier-custom-fields',
    searchByInvoiceId = 'search-by-invoice-id',
    spendAllocation = 'spend-allocation',
    taeCorrectionAutoApproveViaProcess = 'tae-correction-auto-approve-via-process',
    tenantDateFormat = 'tenant-date-format',
    testFeatureFlag = 'test-feature-flag',
    timesheetAttachments = 'timesheet-attachments',
    validateProrationTimeCodeMisconfiguration = 'validate-proration-time-code-misconfiguration',
    validateRoundingHalfUp = 'validate-rounding-half-up'
  }

  export enum StringFlag {}

  export enum NumberFlag {}

  export enum JsonFlag {}
}
